import React, { useEffect } from 'react'

// MUI
import { Box } from '@mui/material'
import { useDispatch } from 'react-redux'
import modalSlice from '../store/state-slices/modalControl'
import { openCreateModal } from '../store/state-slices/modalControl'

export default function CreateEvent() {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(openCreateModal())
    }, [])
    return (
        <Box position={"relative"} sx={{ top: '78px' }}>
            {/* Create Event */}
        </Box>
    )
}
